// import { Question, Option } from "@/shared/question";

import { QuestionService } from "@/services/question/QuestionService";
import { QuestionWebSocketService } from "@/services/question/QuestionWebSocketService";
import { PhotoService } from "@/services/question/PhotoService";

export var questionService = new QuestionService();
export var webSocketService = new QuestionWebSocketService();
export var photoService = new PhotoService();